import React, { useEffect } from 'react';
import { CenteredContainer, ToggleContainer, ToggleButton, Slider } from './ToggleSwitchStyled';
import getAsset from '~/helpers/getAsset';
import clientSide from '~/helpers/clientSide';
import { trackEvent } from '~/helpers/tracking';

const ToggleSwitch = ({
  isCopper,
  clickToToggleNetflixBundle,
  setClickToToggleNetflixBundle,
  netflixToggleDefault,
}) => {
  const toggleActive = () => {
    setClickToToggleNetflixBundle(!clickToToggleNetflixBundle);
    trackEvent({
      action: 'toggleBundles',
      data: {
        detail: {
          text: `${!clickToToggleNetflixBundle ? 'Swap Plans:Netflix Bundle' : 'Swap Plans: Fiber Plans'}`,
        },
      },
    });
    trackEvent({
      action: 'elementClicked',
      data: {
        elementType: 'NETFLIX_TOGGLE',
        location: 'product_selection_page',
        position: 'product_cards',
        text: `Netflix Toggle ${!clickToToggleNetflixBundle ? 'On' : 'Off'}`,
      },
    });
};

  // Set default toggle position - netflix/fiber
  useEffect(() => {
    const netflixProductSessionStorage = clientSide ? window?.sessionStorage.getItem('netflixProduct') : null;

    if (isCopper) {
      // If copper, set to false
      setClickToToggleNetflixBundle(false);
    } // Check directly if 'netflixProduct' exists in sessionStorage from LP's
    else if (netflixProductSessionStorage) {
      // If it exists, parse it and use the parsed result to set the toggle
      const netflixProductResults = JSON.parse(netflixProductSessionStorage);
      setClickToToggleNetflixBundle(netflixProductResults);
    } else {
      // Otherwise take the value that the editable variable is set to
      setClickToToggleNetflixBundle(netflixToggleDefault === 'netflix');
    }
  }, []);

  return (
    <CenteredContainer>
      <ToggleContainer>
        <ToggleButton
          className="netflix-logo-wrapper"
          netflixToggleActive={!clickToToggleNetflixBundle}
          onClick={toggleActive}
        >
          <img src={getAsset(`/images/logos/netflix-logo.svg`)} alt="Netflix Pro & Wi-Fi Bundle" /> Bundle
        </ToggleButton>
        <ToggleButton netflixToggleActive={clickToToggleNetflixBundle} onClick={toggleActive}>
          Fiber Plans
        </ToggleButton>
        <Slider netflixToggleActive={clickToToggleNetflixBundle} />
      </ToggleContainer>
    </CenteredContainer>
  );
};

export default ToggleSwitch;
